<div class="page-layout blank p-24" fusePerfectScrollbar>
    <div class="">
        <h1>¡Bienvenido!</h1>
		<p class="lead">Signus Contratación</p>
			
		<div *ngIf='logued && avisos.length > 0'>
			<h1 class="mt-12">Avisos</h1>
			<mat-card class="p-12 mb-8" fxLayoutAlign='start center' fxLayoutGap='12px' *ngFor='let aviso of avisos'>
				<mat-icon>info</mat-icon>
				<p class="m-0" [innerHTML]="aviso"></p>
			</mat-card>
		</div>

		<div *ngIf="!production">
			<h1>Estas en Modo desarrollo</h1>
			<button (click)="throwError()">Error</button>
			<button (click)="throwHttpError()">HTTP</button>
		</div>
    </div>
</div>